export default "__VITE_ASSET__BzunPs2Q__"